import { IAccBienLaiThietLap } from "../../../model/respone/category/IAccBienLaiThietLap";
import { generateActionTypeIds } from "../generateActionTypeIds";
import IGenericActionType from "../IGenericActionType";

export const eAccBienLaiThietLapActionsObj = {
  LOAD_START: undefined,
  LOAD_SUCCESS: {} as IAccBienLaiThietLap[],
  LOAD_ERRR: "",

  SAVE_START: {} as IAccBienLaiThietLap,
  SAVE_SUCCESS: {} as IAccBienLaiThietLap,
  SAVE_ERROR: "",

  DELETE_START: 0,
  DELETE_SUCCESS: undefined,
  DELETE_ERROR: "",

  SHOW_EDIT_MODAL: {} as undefined | IAccBienLaiThietLap,
  CLOSE_EDIT_MODAL: undefined,
};
export const eAccBienLaiThietLapActionIds = generateActionTypeIds(
  eAccBienLaiThietLapActionsObj,
  "BIEN_LAI_THIET_LAP"
);

export type IAccBienLaiThietLapActionTypes = IGenericActionType<
  typeof eAccBienLaiThietLapActionsObj,
  "BIEN_LAI_THIET_LAP"
>;
